import { WithRestaurantIdEndpoint } from "./WithRestaurantIdEndpoint";
export class PeriodsEndpoint extends WithRestaurantIdEndpoint {
  constructor() {
    super("periods");
  }
}
